import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import {
  Home as HomeIcon,
  PhotoLibrary as PhotoLibraryIcon,
  AddCircle as AddCircleIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { useAlbum } from '../../contexts/AlbumContext';

const BottomNav = () => {
  const { activeTab, setActiveTab, resetApp } = useAlbum();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);

    // 홈 탭 선택 시 앱 리셋
    if (newValue === 0) {
      resetApp();
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
      }}
      elevation={3}
    >
      <BottomNavigation
        value={activeTab}
        onChange={handleChange}
        showLabels
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            marginTop: '4px',
          },
        }}
      >
        <BottomNavigationAction
          label="홈"
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          label="앨범"
          icon={<PhotoLibraryIcon />}
        />
        <BottomNavigationAction
          label="만들기"
          icon={<AddCircleIcon sx={{ fontSize: 32, color: 'primary.main' }} />}
          sx={{
            '& .MuiBottomNavigationAction-label': {
              color: 'primary.main',
            },
          }}
        />
        <BottomNavigationAction
          label="설정"
          icon={<SettingsIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
